import { StyleSheet } from 'react-native-unistyles';

export const styles = StyleSheet.create(() => ({
  container: {
    ...StyleSheet.absoluteFillObject,
    overflow: 'hidden',
  },
}));
